
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const BuyerSection = () => {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  return (
    <section ref={ref} className="py-16 bg-card/20">
      <div className="container mx-auto px-4">
        <div className={`bg-gradient-to-r from-godyspo-gold/20 to-godyspo-blue/40 p-8 md:p-12 rounded-lg text-center transition-all duration-700 ${isVisible ? 'animate-scale-in' : 'opacity-0 scale-95'}`}>
          <h2 className="text-2xl md:text-4xl font-bold mb-4">Looking for Investment Properties?</h2>
          <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
            Access exclusive wholesale deals, connect directly with trusted sellers, and discover your next investment opportunity. Create your free account today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/buyer">
              <Button size="lg" className="bg-godyspo-gold text-godyspo-background hover:bg-godyspo-gold/90 w-full sm:w-auto hover-lift group">
                Explore Investment Properties
                <span className="ml-2 transition-transform group-hover:translate-x-1">→</span>
              </Button>
            </Link>
            <Link to="/buyer/register">
              <Button size="lg" variant="outline" className="border-white text-white w-full sm:w-auto hover-lift">
                Create Free Account
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BuyerSection;
